import React from "react"
import types from "prop-types"
import { useDispatch } from "react-redux"
import { reopenConversation } from "reduxSlices/formSubmissionConversationsSlice"
import { PrimaryButton } from "shared/buttons"

const ConversationActionReopen = ({ conversationId }) => {
  const dispatch = useDispatch()

  const reopen = () => dispatch(reopenConversation({ conversationId }))

  return (
    <PrimaryButton onClick={reopen} text="Reopen Conversation" />
  )
}

ConversationActionReopen.propTypes = {
  conversationId: types.number.isRequired,
}

export default ConversationActionReopen
